<template>
    <div class="pop-up" v-if="show">
        <div class="pop-up-container">
            <span class="close" @click="close">+</span>
            <p>Please Input Password<p/>
            <div>
                <input type="text" v-model="download_password"/>
            </div>
            <p class="msg">{{ msg }}</p>
            <div class="buttons">
                <div class="button button-close" :class="loading ? 'loading' : '' " @click="close">Cancel</div>
                <div class="button" :class="loading ? 'loading' : '' " @click="checkPassword">Submit</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pop-up",
        data(){
            return {
                show:false,
                download_password: '',
                fileInfo:{},
                loading:false,
                msg:''
            }
        },
        methods:{
            open(item){
                this.show = true
                this.fileInfo = item
            },
            checkPassword(){
                if(this.loading){
                    return
                }
                this.loading = true
                let data = {
                    download_password:this.download_password,
                    file_id:this.fileInfo.file_id
                }
                this.$api.check_download_password(data).then(res => {
                    if(res.code){
                        fetch(res.data.file_path)
                            .then(res => res.blob())
                            .then(blob => {
                                const a = document.createElement("a");
                                const objectUrl = window.URL.createObjectURL(blob);
                                a.download = this.fileInfo.title;
                                a.href = objectUrl;
                                a.click();
                                // window.revokeObjectURL(objectUrl);
                            })
                        this.close()
                    }else {
                        this.msg = res.msg
                        this.loading = false
                    }
                })
            },
            close(){
                this.loading = false
                this.msg = ''
                this.show = false
                this.download_password = ''
            }
        }
    }
</script>

<style>
    .pop-up {
        width: 300px;
        height: 230px;
        position: fixed;
        left: 50%;
        top: 50%;
        margin: -100px 0 0 -150px;
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        color: #5d5f5f;
    }

    .pop-up .pop-up-container {
        width: 100%;
    }

    .pop-up .pop-up-container p {
        font-size: 20px;
        text-align: center;
    }

    .pop-up .pop-up-container input {
        display: block;
        width: 250px;
        height: 30px;
        font-size: 20px;
        margin: 0 auto;
        color: #5d5f5f;
        border:1px solid #5d5f5f;
        padding: 5px 10px;
        border-radius: 5px;
    }

    .pop-up .pop-up-container input:focus {
        outline: none;
    }

    .pop-up .pop-up-container {

    }

    .pop-up .pop-up-container .button{
        font-size: 20px;
        background: #409eff;
        color: #ffffff;
        padding: 5px;
        width: 100px;
        text-align: center;
        border-radius: 5px;
        margin: 10px 0;
        cursor: pointer;
    }

    .pop-up .pop-up-container .buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 270px;
        margin: 0 auto;
    }

    .pop-up .pop-up-container .button-close {
        color: #5d5f5f;
        background-color: #ffffff;
        border: 1px solid #5d5f5f;
        transition: all .3s linear 0s;
    }

    .pop-up .pop-up-container .button-close:hover {
        color: #409eff;
        border: 1px solid #409eff;
    }

    .pop-up .pop-up-container .msg {
        width: 270px;
        font-size: 14px;
        color: red;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        text-align: left;
    }

    .pop-up .pop-up-container .loading {
        background: #bbbbbb;
    }

    .pop-up .pop-up-container .close {
        display: block;
        width: 30px;
        height: 30px;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 30px;
        color: #5d5f5f;
        text-align: center;
        transform: rotate(45deg);
        cursor: pointer;
        transition: all .3s linear 0s;
    }
    .pop-up .pop-up-container .close:hover {
        color: #409eff;
    }
</style>